import suggest from '@r1-frontend/api-domru/dadata/suggest/suggest';

const fio = suggest('fio');

export default fio;
